import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const configShop = create(persist(
    (set) => ({
        dataConfig: {
            color_background: "#FFFFFF",
            color_font: "rgb(40, 48, 74)",
            color_font_secundary: "rgb(40, 48, 74)",
            totalReviews: 0,
            title_home: "Bienvenido",
            color_botton: "rgb(40, 48, 74)",
            color_button_text: "#FFFFFF",
            company_logo: "https://develop-oms-sas.s3.amazonaws.com/Pleizt%20OMS/logos/65b2b56b22ca6.png",
            company_name: "App Pleizt",
            img_home: "https://develop-oms-sas.s3.amazonaws.com/Pleizt%20OMS/logos/65b2b56b22ca6.png",
            rating: 0,
            qualification: 0,
            reviews: 0,
            typeView:0,
            page_sedes: {
                background_image: null,
                overlay_brightness: 0.6,
                color_subtitle: "#FFFFFF",
                color_subtitle_description: "rgba(255,255,255,0.82)",
                color_section_label: "rgba(255,255,255,0.65)",
                card: {
                    background: "rgba(255,255,255,0.14)",
                    color_name: "#FFFFFF",
                    color_address: "rgba(255,255,255,0.72)",
                    icon_background: "#6C63FF",
                    icon_color: "#FFFFFF",
                    arrow_color: "rgba(255,255,255,0.55)"
                }
            }
        },
        setDataConfig: (updatedFields) => set((state) => ({
            dataConfig: {
                ...state.dataConfig,
                ...updatedFields
            }
        })),       
        resetDataConfig: () => set(() => ({
            dataConfig: {
                color_background: "rgb(40, 48, 74)",
                color_botton: "rgb(40, 48, 74)",
                color_hover: "rgb(40, 48, 74)",
                company_logo: "https://develop-oms-sas.s3.amazonaws.com/Pleizt%20OMS/logos/65b2b56b22ca6.png",
                company_name: "App Pleizt",
                img_home: "https://develop-oms-sas.s3.amazonaws.com/Pleizt%20OMS/logos/65b2b56b22ca6.png"
            }
        }))
    }),
    {
        name: 'config-shop-pleizt', // nombre para localStorage
    }
));
